"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var Matrix = /** @class */ (function (_super) {
    tslib_1.__extends(Matrix, _super);
    function Matrix() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Matrix.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'matrix';
        _super.prototype.createLayers.call(this, layerProps);
    };
    Matrix.prototype.changeShape = function (type) {
        var layer = this.layers[0];
        layer.changeShape(type);
    };
    Matrix.prototype.mappingSize = function (field) {
        var layer = this.layers[0];
        layer.mappingSize(field);
    };
    Matrix.prototype.disableMappingSize = function () {
        var layer = this.layers[0];
        layer.disableMappingSize();
    };
    Matrix.getDefaultOptions = layer_1.default.getDefaultOptions;
    return Matrix;
}(plot_1.default));
exports.default = Matrix;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/matrix/index.js
// module id = 936
// module chunks = 37